import { DialogCloseEvent } from '@theme/dialog';

const STORAGE_KEY = 'home-announcement-popup-seen';

/**
 * @param {Element | null} popup
 * @returns {boolean}
 */
function isFirstVisitOnly(popup) {
  return popup?.dataset.showFrequency !== 'every_visit';
}

/**
 * @returns {boolean}
 */
function hasSeenPopup() {
  if (window.__homeAnnouncementPopupBlock) return true;

  try {
    if (sessionStorage.getItem(STORAGE_KEY) === '1') return true;
  } catch (_) {
    /* storage unavailable */
  }

  return document.cookie.split(';').some((part) => part.trim().startsWith(`${STORAGE_KEY}=1`));
}

/**
 * Remember that the visitor has had the homepage popup this session.
 */
function markPopupSeen() {
  window.__homeAnnouncementPopupBlock = true;

  try {
    sessionStorage.setItem(STORAGE_KEY, '1');
  } catch (_) {
    /* storage unavailable */
  }

  document.cookie = `${STORAGE_KEY}=1; path=/; SameSite=Lax`;
}

/**
 * @param {Element} element
 * @returns {element is import('@theme/dialog').DialogComponent}
 */
function isDialogComponent(element) {
  return element != null && typeof /** @type {any} */ (element).showDialog === 'function';
}

function initHomeAnnouncementPopup() {
  const popup = document.querySelector('dialog-component.home-announcement-popup');
  if (!isDialogComponent(popup)) return;

  const isDesignMode = popup.hasAttribute('data-design-mode');
  const firstVisitOnly = isFirstVisitOnly(popup);

  if (!isDesignMode && firstVisitOnly && hasSeenPopup()) return;

  if (!isDesignMode && firstVisitOnly) {
    popup.addEventListener(DialogCloseEvent.eventName, markPopupSeen);
    window.addEventListener('pagehide', markPopupSeen, { once: true });
    window.addEventListener('pageswap', markPopupSeen, { once: true });
  }

  const delay = (Number(popup.dataset.delay) || 0) * 1000;

  window.setTimeout(() => {
    if (!isDesignMode && firstVisitOnly && hasSeenPopup()) return;
    popup.showDialog();
  }, delay);
}

function start() {
  customElements.whenDefined('dialog-component').then(initHomeAnnouncementPopup);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
